import { useGameContainer } from '../index';
import Table, { TableCell, TableHeaderCell, TableLinkRow, TableRow } from '@/components/Table';
import { COMPLETED } from 'constants/GameStatuses';
import styles from './styles/GameTeamComparison.module.scss';
import TeamImage from 'components/TeamImage';
import ContentSection, { ContentSectionFlushContent, ContentSectionHeader } from '@/components/ContentSection';
import { SectionHeaderSize } from '@/components/SectionHeader';
import TextLink from '@/components/TextLink';

export default function GameTeamComparison() {
  const [{ game }] = useGameContainer();

  if (game.statusId === COMPLETED) return null;

  const gameTeams = game.gameTeams.filter(({ isTbd }) => !isTbd);

  return (
    <ContentSection>
      <ContentSectionHeader size={SectionHeaderSize.LARGE}>Team Comparison</ContentSectionHeader>
      <ContentSectionFlushContent>
        {/* SMALL TABLE DISPLAY */}
        <Table
          className={styles.SmallTable}
          header={
            <>
              <TableHeaderCell />
              {gameTeams.map(({ id, team }) => (
                <TableHeaderCell align="right" key={id}>
                  <TeamImage alt={team.name} src={team.image} style={{ height: '24px', width: '24px' }} />
                </TableHeaderCell>
              ))}
            </>
          }
        >
          <TableRow>
            <TableCell>Overall</TableCell>
            {gameTeams.map(({ id, standing }) => (
              <TableCell key={id} align="right">
                {standing.overallRecord}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Home</TableCell>
            {gameTeams.map(({ id, standing }) => (
              <TableCell key={id} align="right">
                {standing.homeRecord}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Away</TableCell>
            {gameTeams.map(({ id, standing }) => (
              <TableCell key={id} align="right">
                {standing.awayRecord}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Win %</TableCell>
            {gameTeams.map(({ id, standing }) => (
              <TableCell key={id} align="right">
                {standing.overallWinPercentage}
              </TableCell>
            ))}
          </TableRow>
        </Table>
        {/* LARGE TABLE DISPLAY */}
        <Table
          className={styles.LargeTable}
          header={
            <>
              <TableHeaderCell>Team</TableHeaderCell>
              <TableHeaderCell align="right">Overall</TableHeaderCell>
              <TableHeaderCell align="right">Home</TableHeaderCell>
              <TableHeaderCell align="right">Away</TableHeaderCell>
              <TableHeaderCell align="right">Win %</TableHeaderCell>
            </>
          }
        >
          {gameTeams.map(({ id, team, standing }) => {
            return (
              <TableLinkRow key={id} href={team.webPath}>
                <TableCell>
                  <TextLink href={team.webPath}>
                    <TeamImage alt={team.name} src={team.image} style={{ height: '20px' }} />
                    {team.name}
                  </TextLink>
                </TableCell>
                <TableCell align="right">{standing.overallRecord}</TableCell>
                <TableCell align="right">{standing.homeRecord}</TableCell>
                <TableCell align="right">{standing.awayRecord}</TableCell>
                <TableCell align="right">{standing.overallWinPercentage}</TableCell>
              </TableLinkRow>
            );
          })}
        </Table>
      </ContentSectionFlushContent>
    </ContentSection>
  );
}
